import { render, staticRenderFns } from "./plesson.vue?vue&type=template&id=39ab998e&scoped=true&"
import script from "./plesson.vue?vue&type=script&lang=js&"
export * from "./plesson.vue?vue&type=script&lang=js&"
import style0 from "./plesson.vue?vue&type=style&index=0&id=39ab998e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab998e",
  null
  
)

export default component.exports